import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ChartjsPluginStacked100 from 'chartjs-plugin-stacked100';

Chart.register([ChartDataLabels, ChartjsPluginStacked100]);

let chart;

export const convertChartToSvg = (options) => {
  const canvas = document.createElement('canvas');

  if (chart) {
    chart.destroy();
  }

  const config = {
    data: {
      labels: options.labels,
      datasets: options.datasets,
    },
    options: options.options,
  };

  if (options?.type) {
    config.type = options.type;
  }

  canvas.width = options.width;
  canvas.height = options.height;

  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';

  chart = new Chart(ctx, config);

  const dataUrl = chart.toBase64Image();

  return { svg: dataUrl };
};
